import React, { ReactElement } from 'react';

import { MenuItem as RCMenuItem } from 'rc-menu';

import { MENU_CLASS } from '../../../../utils/constants';
import { ChevronSmallRight } from '../../../Icon/components';
import { IMenuItemProps } from './MenuItem.types';

const MenuItem = ({ children, flyOut = false, disabled = false, ...rest }: IMenuItemProps): ReactElement => (
  <RCMenuItem
    aria-label={rest.eventKey}
    itemIcon={flyOut ? <ChevronSmallRight className={`${MENU_CLASS}-item-flyout`} /> : null}
    disabled={disabled}
    {...rest}
  >
    <div className={`${MENU_CLASS}-item-content`}>{children}</div>
  </RCMenuItem>
);

export default MenuItem;
